import type { ReactElement, ReactNode } from 'react'

import { isNil } from 'ramda'

import type { CastedSubmitHandler } from '@twisto/components/atoms/form'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'

import { FlowFormSubmitButton } from './flow-form-submit-button'
import * as styles from './flow-form-submit-info-view.styles'

type Props = {
  title: ReactElement | string
  buttonText?: ReactElement | string
  subtitle?: ReactElement | string | Array<ReactElement | string>
  icon?: ReactNode
  onSubmit: CastedSubmitHandler<Record<string, never>>
}

export const FlowFormSubmitInfoView = ({
  onSubmit,
  icon,
  title,
  subtitle,
  buttonText,
}: Props) => {
  const renderSubtitle = () => {
    const subtitles = Array.isArray(subtitle) ? subtitle : [subtitle]

    return subtitles.map((sub, index) => (
      <HeadlineSubtitle key={index}>{sub}</HeadlineSubtitle>
    ))
  }

  return (
    <>
      <Headline css={styles.headline}>
        {!isNil(icon) && <HeadlineIcon>{icon}</HeadlineIcon>}
        <HeadlineTitle>{title}</HeadlineTitle>
        {!isNil(subtitle) && renderSubtitle()}
      </Headline>
      <FlowFormSubmitButton buttonText={buttonText} onSubmit={onSubmit} />
    </>
  )
}
